/**
 * Model to hold a sport as defined in identity
 */
export class IdentitySport {
    public id: string = null;
    public name: string = null;

    constructor(id: string = null) {
        this.id = id;
    }

    public clone(): IdentitySport {
        const clone: IdentitySport = new IdentitySport();
        clone.id = this.id;
        clone.name = this.name;

        return clone;
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any): IdentitySport {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'];

        this.id = data.id;
        this.name = attrs.name;

        return this;
    }
}
